"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/ParticipantsBoard/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Participant = require('web/screens/VideoCall/Participant'); var _Participant2 = _interopRequireDefault(_Participant);
var _uiUtils = require('web/components/VideoCall/OnCall/uiUtils');


const noEvents = []










// Was a plain class component (no memo, as before): it re-renders with OnCall,
// and each Participant container decides for itself.
const ParticipantsBoard = ({
  isHidden,
  ignoredUIEvents = noEvents,
  roomKey, activeParticipantId,
  participants, onParticipantPick,
}) => {
  const [isParticipantsListOpen, setIsParticipantsListOpen] = _react.useState.call(void 0, true)
  const rootRef = _uiUtils.useStopPropagation.call(void 0, ignoredUIEvents)

  const toggleParticipantsList = () => setIsParticipantsListOpen(!isParticipantsListOpen)

  const participantsList = Object.values(participants)

  const rootClassName = _classBuilder2.default.call(void 0, 
    "video-call--participants-board",
    { hidden: !isParticipantsListOpen },
    { "mobile-hidden": isHidden },
  )
  const listClassName = _classBuilder2.default.call(void 0, 
    "meeting--participants--list",
    { hidden: !isParticipantsListOpen },
  )
  const listToggleClassName = _classBuilder2.default.call(void 0, 
    "meeting--participants--more-toggle",
    { hidden: !isParticipantsListOpen },
  )

  const participantsCountLabel = `${participantsList.length} Participants`

  return (
    _react2.default.createElement('div', { className: rootClassName, ref: rootRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
      , _react2.default.createElement('div', { className: listClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
        , _react2.default.createElement('div', { className: "meeting--participants--list-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
          ,  participantsList.map(p =>
              _react2.default.createElement(_Participant2.default, {
                key: p.id,
                roomKey: roomKey,
                roomUserKey: p.RoomUserKey,
                participantKey: p.id,
                name: p.name,
                isScreenParticipant: p.isScreenParticipant,
                isActive: p.id === activeParticipantId,
                isMe: p.local,
                isLoading: p.isLoading,
                onPick: onParticipantPick,
                audioTrack: p.audioTrack,
                videoTrack: p.videoTrack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
              ),
          )
          
        )
      )
      , _react2.default.createElement('div', {
        className: listToggleClassName,
        onClick: toggleParticipantsList, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}

        , _react2.default.createElement('div', { className: "meeting--participants--more-toggle--inner inner--open" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
          , _react2.default.createElement('span', { className: "meeting--participants--more-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
            ,  participantsCountLabel 
          )
          , _react2.default.createElement('div', { className: "meeting--participants--more-spacer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}} )
          , _react2.default.createElement('div', { className: "meeting--participants--more-arrow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}} )
        )
        , _react2.default.createElement('div', { className: "meeting--participants--more-toggle--inner inner--collapsed" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
          , _react2.default.createElement('div', { className: "meeting--participants--more-arrow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
          , _react2.default.createElement('div', { className: "meeting--participants--more-spacer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}} )
          , _react2.default.createElement('div', { className: "meeting--participants--more-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}} )
          , _react2.default.createElement('span', { className: "meeting--participants--more-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, "Show ("
             ,  participantsList.length , ")"
          )
        )
      )
    )
  )
}

exports. default = ParticipantsBoard
